// @flow
import type { Epic } from '../../annotations';

import * as r from 'ramda';
import * as most from 'most';
import { select } from 'redux-most';
import { initialize } from 'redux-form';
import * as signals from '../signals';
import * as messages from '../../domain/messages';
import * as mostc from '../../crosscutting/mostc';

const seedEpic = (): Epic => (actions$) => r.pipe(
  select(signals.SEED),
  mostc.map(({
    payload,
  }) => {
    return r.pipe(
      r.append(
        messages.seeded(
          payload.query,
          payload.brandId,
          payload.exchangeRate,
          payload.minTldLength,
          payload.bundle,
          payload.features,
          payload.asyncHooks,
          payload.usePPE,
          payload.includeTax,
          payload.unspunTlds,
          payload.filters,
        )
      ),
      r.when(
        r.always(r.is(String, payload.query)),
        r.pipe(
          r.append(
            signals.search(
              payload.query,
              payload.filters,
              'seed'
            ),
          ),
          r.append(
            initialize(
              'domainSearch',
              { query: payload.query },
              { keeyDirty: false },
            ),
          ),
        ),
      ),
      most.from,
    )([]);
  }),
  most.switchLatest,
)(actions$);

export default seedEpic;
